import React from "react";
import { Button, ButtonToolbar, Row, Col } from 'react-bootstrap'
import Modal from 'react-responsive-modal';
import { reduxForm, Field } from 'redux-form';
import { connect } from 'react-redux';

import { JOB_LOST_FORM_NAME } from "helpers/FormNames"
import { validate } from 'form-validations/validation-job-lost-form'
import { RenderTextArea, RenderSelect } from "shared/render-field";

class JobLostModal extends React.Component {
  constructor(props) {
    super(props);
  }

  componentWillUnmount() {
    Modal.prototype.componentWillUnmount = () => {}
  }

  render() {
    const { show, close, submitting, handleSubmit, lostReasons } = this.props;
    return (
      <Modal
        little
        closeOnEsc={false}
        closeOnOverlayClick={false}
        open={show} onClose={close}
      >
        <form onSubmit={handleSubmit}>
          <Row>
            <Col md={12}>
              <h3 className="margin-top-0">Mark job as lost</h3>
            </Col>
          </Row>
          <Row>
            <Col md={5} sm={7}>
              <Field label="Lost Reason" name="lost_reason" component={RenderSelect} options={lostReasons} />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <Field name="note" label="Lost notes" component={RenderTextArea} />
            </Col>
          </Row>
          <ButtonToolbar className="pull-right">
            <Button onClick={close}>Close</Button>
            <button className="btn btn-primary" type="submit" disabled={submitting}>Save</button>
          </ButtonToolbar>
        </form>
      </Modal>
    )
  }
}

JobLostModal = reduxForm({
  form: JOB_LOST_FORM_NAME,
  validate,
  enableReinitialize : true
})(JobLostModal);
JobLostModal = connect(
  state => ({
    initialValues: state.jobLost.data,
  })
)(JobLostModal);

export default JobLostModal;

